import React, { useContext, useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import "../assets/scss/core.scss";
import common from "../config/config.common";
import { AuthContext } from "../context/AuthContext";
import useApiClient, { apiRoutes } from "../hooks/apiClient";
import appConfig from "../config/app.config";
import ImgMarca from "../assets/img/marca-horizontal-cor.png";

const submitSignin = (credentials, request) => {
  const headers = {
    Authorization: `Basic ${window.btoa(`${credentials.codigoUsuario.toUpperCase()}:${credentials.password}`)}`,
    captcha_token: credentials.captchaData.result.secret,
    captcha_value: credentials.captcha,
  };

  const params = {
    scope: "openid",
    response_type: "code id_token",
    client_id: common.clientId,
    redirect_uri: "https://efis.sefaz.rn.gov.br",
    state: Math.random().toString(36).slice(2),
  };

  request(apiRoutes.auth.autenticacao.signInBasic, params, { headers });
};

const Login = () => {
  const authContext = useContext(AuthContext);

  const { request: requestCaptcha, data: captchaData } = useApiClient(false);

  const { request: requestSignin, data: signinData, errors: signinErros, isLoading } = useApiClient();

  const { request: requestSigninSso, data: signinSsoData } = useApiClient(false);

  const [codigoUsuario, setCodigoUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState(appConfig.env === "prod" ? "" : "N0N35");
  const [showErro, setshowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");

  useEffect(() => {
    localStorage.clear();
    requestCaptcha(apiRoutes.auth.autenticacao.getCaptcha);
  }, [requestCaptcha]);

  useEffect(() => {
    if (signinData) {
      authContext.handleLogin(signinData);
    } else if (signinErros) {
      setMessageErro(signinErros.message);
      setshowErro(true);
    }
  }, [signinData, signinErros, authContext]);

  useEffect(() => {
    if (signinSsoData) {
      authContext.handleLogin(signinSsoData);
    }
  }, [signinSsoData, authContext]);

  useEffect(() => {
    requestSigninSso(apiRoutes.auth.autenticacao.signInSso);
  }, [requestSigninSso]);

  return (
    <div className="container">
      {/* Outer Row */}
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              {/* Nested Row within Card Body */}
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block bg-login-image" />
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <img
                        src={ImgMarca}
                        width="50%"
                        className="d-inline-block align-top pb-5 d-lg-none"
                        alt="efis logo"
                      />
                      <h1 className="h4 text-gray-900 mb-4">Bem vindo(a)!</h1>
                    </div>
                    <form className="login">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control form-control-login"
                          onChange={(e) => setCodigoUsuario(e.target.value)}
                          placeholder="Entre com seu usuário"
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control form-control-login"
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Digite sua senha"
                        />
                      </div>
                      <div className="form-group text-center">
                        {captchaData && <img src={captchaData.result.arquivo} alt="Captcha" className="w-100" />}
                        <p className="mt-3">
                          <Button
                            variant="link"
                            onClick={() => {
                              setCaptcha("");
                              requestCaptcha(apiRoutes.auth.autenticacao.getCaptcha);
                            }}
                          >
                            <i className="fas fa-sync-alt" />
                            &nbsp;Recarregar captcha
                          </Button>
                        </p>
                      </div>
                      <div className="form-group text-center">
                        <input
                          type="text"
                          className="form-control form-control-login"
                          value={captcha}
                          onChange={(e) => setCaptcha(e.target.value)}
                          placeholder="Digite o captcha"
                        />
                      </div>
                      {/* <div className="form-group">
                      <div className="custom-control custom-checkbox small">
                        <input type="checkbox" className="custom-control-input" id="customCheck" />
                        <label className="custom-control-label" htmlFor="customCheck">
                          Lembrar-me
                        </label>
                      </div>
                    </div> */}
                      <div className="form-group text-center">
                        {showErro ? (
                          <>
                            <br />
                            <div className="alert alert-danger" role="alert">
                              {messageErro}
                            </div>
                          </>
                        ) : null}
                        {isLoading ? (
                          <span>
                            <Spinner animation="border" role="status" />
                            &nbsp;Acessando...
                          </span>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              submitSignin(
                                {
                                  codigoUsuario,
                                  password,
                                  captcha,
                                  captchaData,
                                },
                                requestSignin,
                              );
                            }}
                            disabled={!codigoUsuario || !password || !captcha || !captchaData}
                            className="btn btn-secondary btn-login btn-block"
                          >
                            Entrar
                          </button>
                        )}
                      </div>
                      {/* <div>
                        <button
                          type="button"
                          className="btn btn-primary btn-login btn-block"
                          onClick={() => {
                            window.location = `${appConfig.hosts.auth}v1/sso/auth?client_id=54bcfa1d`;
                          }}
                        >
                          SSO SEFAZ-RN
                        </button>
                      </div> */}
                    </form>
                    <hr />
                    <div className="text-center">
                      <Button variant="link" className="small">
                        Esqueceu seus dados?
                      </Button>
                    </div>
                    <div className="text-center">
                      <Button variant="link" className="small">
                        Crie sua conta!
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
